"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyConfirmationSupportInfo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const BuyConfirmationSupportInfo = ({ support }) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { marginBottom: 3 } }, tablet: { spacing: { marginBottom: 4 } }, children: (0, jsx_runtime_1.jsxs)(cotopaxi_1.Text, { type: cotopaxi_1.TextType.CONTENT, children: [support.info, " ", (0, jsx_runtime_1.jsx)(cotopaxi_1.Link, { href: support.href, children: support.linkLabel })] }) }));
exports.BuyConfirmationSupportInfo = BuyConfirmationSupportInfo;
